import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { LcDatePickerModule } from "@libusoftcicom/lc-datepicker";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { MomentModule } from "angular2-moment";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { AngularFireModule } from "angularfire2";
import { AngularFireAuthModule } from "angularfire2/auth";
import { AngularFireDatabaseModule } from "angularfire2/database";
import { AngularFireStorageModule } from "angularfire2/storage";
import { MyDatePickerModule } from "mydatepicker";
import { ANIMATION_TYPES, LoadingModule } from "ngx-loading";
import { OrderModule } from "ngx-order-pipe";
import { NgxPaginationModule } from "ngx-pagination";
import { PapaParseModule } from "ngx-papaparse";
import { TimeAgoPipe } from "time-ago-pipe";
import { AuthService } from "../app/shared/services/auth.service";
import { BackendService } from "../app/shared/services/backend.service";
import { FileUploadService } from "../app/shared/services/fileuploadservice";
import environment from "../environments/environment";
import { AppRoutingModule } from ".//app-routing.module";
import { AccountComponent } from "./account/account";
import { LoginComponent } from "./account/login/login.component";
import { PasswordResetComponent } from "./account/password-reset/password-reset.component";
import { AdministratorComponent } from "./administrator/administrator.component";
import { AppComponent } from "./app.component";
import { BillComponent } from "./bill/bill.component";
import { CreateBillTypeComponent } from "./bill/create-bill-type/create-bill-type.component";
import { ManageBillTypeComponent } from "./bill/manage-bill-type/manage-bill-type.component";
import { OutstandingBillsComponent } from "./bill/outstanding-bills/outstanding-bills.component";
import { PaymentLogComponent } from "./bill/payment-log/payment-log.component";
import { PaymentVerificationComponent } from "./bill/payment-verification/payment-verification.component";
import { RemindersComponent } from "./bill/reminders/reminders.component";
import { SelectCommunityComponent } from "./bill/select-community/select-community.component";
import { SetUpBillTypeComponent } from "./bill/set-up-bill-type/set-up-bill-type.component";
import { ViewBillTypeComponent } from "./bill/view-bill-type/view-bill-type.component";
import { BillManagementComponent } from "./community-management/bill-management/bill-management.component";
import { CommunityCardsComponent } from "./community-management/community-cards/community-cards.component";
import { CommunityManagementComponent } from "./community-management/community-management.component";
import { AccessTerminalComponent } from "./community-management/community-resources/access-terminal/access-terminal.component";
import { CommunityManagerComponent } from "./community-management/community-resources/community-manager/community-manager.component";
import { CommunityResourcesComponent } from "./community-management/community-resources/community-resources.component";
import { ShiftsComponent } from "./community-management/community-resources/shifts/shifts.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { BaseComponent } from "./layout/base/base.component";
import { SideBarComponent } from "./layout/side-bar/side-bar.component";
import { NoticeBoardComponent } from "./notice-board/notice-board.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { FilterPipe } from "./pipes/filter.pipe";
import { PollsComponent } from "./polls/polls.component";
import { ViewPollComponent } from "./polls/view-poll/view-poll.component";
import { PropertyManagementComponent } from "./property-management/property-management.component";
import { ResidentManagementComponent } from "./resident-management/resident-management.component";
import { AccountService } from "./shared/account/account.service";
import { BillTypeService } from "./shared/bill/bill-type.service";
import { BillService } from "./shared/bill/bill.service";
import { PaymentService } from "./shared/payment/payment.service";
import { PropertyService } from "./shared/property/property.service";
import { ResidentService } from "./shared/services/user/resident.service";
import { CommunityService } from "./shared/services/community/community.service";
import { AuthGuard } from "./shared/services/guards/auth.guard";
import { LoaderService } from "./shared/services/loader.service";
import { NoticeBoardService } from "./shared/services/notice-board/notice-board.service";
import { NotificationService } from "./shared/services/notification.service";
import { CanAccessDirective } from "./shared/services/permission/directive/can-access.directive";
import { PollService } from "./shared/services/poll/poll.service";
import { ReminderService } from "./shared/services/reminder/reminder.service";
import { AccessTerminalService } from "./shared/services/user/access-terminal.service";
import { AdminService } from "./shared/services/user/admin.service";
import { CommunityManagerService } from "./shared/services/user/community-manager.service";
import { UnitService } from "./shared/unit/unit.service";
import { ProfileService } from "./shared/user/profile.service";
import { UserService } from "./shared/user/user.service";
import { UnitManagementComponent } from "./unit-management/unit-management.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { ShiftService } from "./shared/services/shift/shift.service";
import { SortPipe } from "./pipes/sort.pipe";
import { StringGenerator } from "./shared/string/generator";
import { BasicComponent } from "./basic/basic.component";
import { LocationComponent } from "./basic/location/location.component";
import { CountryComponent } from "./basic/location/country/country.component";
import { StateComponent } from "./basic/location/state/state.component";
import { CityComponent } from "./basic/location/city/city.component";
import { CountryService } from "./shared/location/country.service";
import { AnthemsData, CountriesData, LanguagesData } from "./shared/location/countries-data";
import { StateService } from "./shared/location/state.service";
import { CityService } from "./shared/location/city.service";
import { TermsComponent } from "./terms/terms.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { BlockCopyPasteDirective } from "./shared/services/permission/directive/block-copy-paste.directive";
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  declarations: [
    AppComponent,
    AccountComponent,
    LoginComponent,
    PasswordResetComponent,
    DashboardComponent,
    BillComponent,
    SideBarComponent,
    BaseComponent,
    CreateBillTypeComponent,
    ViewBillTypeComponent,
    PaymentLogComponent,
    ViewBillTypeComponent,
    SetUpBillTypeComponent,
    ManageBillTypeComponent,
    FilterPipe,
    CanAccessDirective,
    SelectCommunityComponent,
    PaymentVerificationComponent,
    RemindersComponent,
    OutstandingBillsComponent,
    NotificationsComponent,
    AdministratorComponent,
    UserProfileComponent,
    CommunityManagementComponent,
    CommunityCardsComponent,
    CommunityResourcesComponent,
    CommunityManagerComponent,
    AccessTerminalComponent,
    PropertyManagementComponent,
    UnitManagementComponent,
    ResidentManagementComponent,
    NoticeBoardComponent,
    TimeAgoPipe,
    PollsComponent,
    ViewPollComponent,
    BillManagementComponent,
    ShiftsComponent,
    SortPipe,
    BasicComponent,
    LocationComponent,
    CountryComponent,
    StateComponent,
    CityComponent,
    TermsComponent,
    PrivacyPolicyComponent,
    BlockCopyPasteDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    AngularFireModule.initializeApp(
      environment.firebase,
      "angular-auth-firebase"
    ),
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    NgbModule.forRoot(),
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.wanderingCubes,
      backdropBackgroundColour: "rgba(255,255,255,0.7)",
      backdropBorderRadius: "0",
      primaryColour: "#137ee0",
      secondaryColour: "#ffc000",
      tertiaryColour: "#137ee0"
    }),
    NgxPaginationModule,
    LcDatePickerModule,
    AngularMultiSelectModule,
    OrderModule,
    PapaParseModule,
    MyDatePickerModule,
    CKEditorModule
  ],
  providers: [
    AccountService,
    AuthGuard,
    AuthService,
    ReminderService,
    PollService,
    AdminService,
    AccessTerminalService,
    CommunityManagerService,
    BackendService,
    FileUploadService,
    BillTypeService,
    BillService,
    CommunityService,
    LcDatePickerModule,
    LoaderService,
    PaymentService,
    ProfileService,
    PropertyService,
    NgxPaginationModule,
    NoticeBoardService,
    NotificationService,
    ResidentService,
    UnitService,
    UserService,
    ShiftService,
    StringGenerator,
    CountryService,
    AnthemsData,
    CountriesData,
    LanguagesData,
    StateService,
    CityService
  ],
  bootstrap: [AppComponent],
  exports: [CommunityManagerComponent, AccessTerminalComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts